import React, { FC } from 'react'
import * as yup from 'yup'
import { Button } from '@docpace/shared-react-components/Button'

import {
    useReactHookForm,
    UseReactHookFormProps,
} from '@docpace/shared-react-hooks/useReactHookForm'
import {
    IndeterminateCheckbox,
} from '@docpace/shared-react-components/IndeterminateCheckbox'
import { useWatch } from 'react-hook-form'
import { FormSubmitControls } from '@docpace/shared-react-components'

export interface AdminUpdateItemTristateFormProps
    extends Omit<UseReactHookFormProps, 'schema'> {
    name: string
    title?: string
    saveOnChange?: boolean
    indeterminateOnNull?: boolean
    onCancel?: () => any
}

export const AdminUpdateItemTristateForm: FC<AdminUpdateItemTristateFormProps> = (
    props
) => {
    const {
        onCancel,
        name,
        title,
        saveOnChange,
        indeterminateOnNull = true,
        ...reactHookProps
    } = props
    const schema = {
        [name]: yup.boolean().nullable(),
    }
    const { FormWrapper, formController, submitError, doSubmit } =
        useReactHookForm({
            ...reactHookProps,
            schema,
        })

    const { getValues, setValue, control } = formController
    const watchedValue = useWatch({ control, name })

    const defaultValue = reactHookProps?.defaultValues?.[name]

    const isDefaultValue =
        typeof defaultValue !== 'undefined' &&
        typeof defaultValue === typeof watchedValue &&
        defaultValue === watchedValue

    return (
        <FormWrapper formComponentProps={{ autoComplete: 'off' }}>
            <div className='inline-block' onClick={async () => {
                    if (indeterminateOnNull && watchedValue === false) {
                        setValue(name, null)
                    } else {
                        setValue(name, !watchedValue)
                    }
                    saveOnChange && await doSubmit(getValues())
                }}>
            <IndeterminateCheckbox
                indeterminateOnNull={indeterminateOnNull}
                isChecked={watchedValue}
            />
            </div>
            {!saveOnChange && <FormSubmitControls onCancel={onCancel} submitError={submitError} /> }
        </FormWrapper>
    )
}
